import Clipboard from 'clipboard'

$(document).on('DOMContentLoaded', () => {
  const invitationCodeSelector= '.js-invitation-code-content'
  const clipboard = new Clipboard(invitationCodeSelector)
  clipboard.on('success', () =>
    alert($(invitationCodeSelector).data('copied-text'))
  )
})
